import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { storeDetail } from "../../actions/store/store";
import PageHeader from "../../components/page/PageHeader";
import { HomePageURL } from "../../assets/const";
import { update_page_meta } from "../../actions/page/header";

const StoreDetail = ({ update_page_meta }) => {
    const { storeSlug } = useParams();
    let navigate = useNavigate();
    const [Store, setStore] = useState(null);
    useEffect(() => {
        const fetch = async () => {
            let res = await storeDetail(storeSlug)
            if (res.success)
                setStore(res.store);
            else
                setStore(null)
        }
        fetch();
    }, [storeSlug]);
    useEffect(() => {
        if (Store){
            update_page_meta({
                title: `${Store?.name} | Store`,
                description: `${Store?.name} is a store registered with Apogee mattress`
            })
        }
    }, [Store, update_page_meta]);
    return (
        <>
            <PageHeader title={Store?.name} />

            <div class="row layout-top-spacing" id="cancel-row">
                <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                    <button class="btn btn-primary mb-2 me-2" onClick={() => navigate(`${HomePageURL}/stores/visits/?store=${Store?.slug}`, {replace: false})}>
                        Registered Visits
                    </button>
                    <button class="btn btn-primary mb-2 me-2" onClick={() => navigate(`${HomePageURL}/stores/orders/?store=${Store?.slug}`, {replace: false})}>
                        View Orders
                    </button>
                </div>
            </div>
        </>
    )
}

export default connect(null, { update_page_meta })(StoreDetail);